import * as Option from "fp-ts/lib/Option";
import { checkForCountdown, checkForArrow, checkForVtmGoWithOnAir, } from "hero/ctaVariant";
export function getCustomDynamicCtaVariant(data) {
    var countdown = checkForCountdown(data);
    if (Option.isSome(countdown))
        return countdown.value;
    var arrow = checkForArrow(data);
    if (Option.isSome(arrow))
        return arrow.value;
    var vtmGo = checkForVtmGoWithOnAir(data);
    if (Option.isSome(vtmGo))
        return vtmGo.value;
    return { kind: "Blank" };
}
